/*
 * @Author: your name
 * @Date: 2022-03-28 14:05:28
 * @LastEditTime: 2022-04-06 13:40:21
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\views\process-center\process-center.routing.ts
 */
export const ProcessCenterRouting = {
  path: "/process-center/:more?",
  name: "process-center",
  meta: { title: "流程中心", icon: "process-center" },
  component: () => import("@/views/process-center/index.vue"),
  
};
